(() => {
  angular.module('app').component('hostHospitalizationExclusionsComponent', {
    templateUrl: require('./exclusions.component.html'),
    controller: ExclusionsComponentController,
    controllerAs: 'vm',
    bindings: {
      exclusions: '<',
      loading: '<',
      accountOwnerId: '=',
    },
  });

  ExclusionsComponentController.$inject = [
    '$sce',
    'moment',
    '$timeout',
    'Hms.Services.ServiceType',
  ];

  function ExclusionsComponentController($sce, moment, $timeout, enumServiceType) {
    const vm = this;
    const today = moment();

    vm.enums = {};

    vm.enums = {
      serviceType: enumServiceType,
    };

    vm.$onInit = init;
    vm.displaySafeHtml = displaySafeHtml;
    vm.showEffectiveDate = showEffectiveDate;

    $timeout(() => {
      $('.box-container').slimScroll({
        height: '400px',
        railOpacity: 0.4,
      });
    }, 0);

    function init() {}

    /* Functions */

    function displaySafeHtml(html) {
      return $sce.trustAsHtml(html);
    }

    function showEffectiveDate(date) {
      return moment(date) > today;
    }

    /* End of Functions */
  }
})();
